import { render, staticRenderFns } from "./localCreate.vue?vue&type=template&id=d7cd9dfe&"
import script from "./localCreate.vue?vue&type=script&lang=js&"
export * from "./localCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7cd9dfe')) {
      api.createRecord('d7cd9dfe', component.options)
    } else {
      api.reload('d7cd9dfe', component.options)
    }
    module.hot.accept("./localCreate.vue?vue&type=template&id=d7cd9dfe&", function () {
      api.rerender('d7cd9dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/localCreate.vue"
export default component.exports